import React from 'react';
import "../CSS/fonts.css"
import "../CSS/registration_fees.css"
import NavBar from '../Components/NavBar';

let Registration_Fees = function(){
    return(
        <>  
            <NavBar></NavBar>
            <h1>Registration Fees</h1>

            <table className = "registration-fees-table">
                <tr>
                    <th>Participants</th>
                    <th>Early Bird Registration <br></br>
                    (IEEE Members)</th>
                    <th>Regular Registration<br></br>
                    (IEEE Members)</th>
                    <th>Early Bird Registration <br></br>
                    (Non-IEEE Members)</th>
                    <th>Regular Registration <br></br>(Non-IEEE Members)</th>
                </tr>
                
                <tr>
                    <td>Students (UG/PG)</td>
                    <td>120 USD</td>
                    <td>150 USD</td>
                    <td>150 USD</td>
                    <td>180 USD</td>
                </tr>
                <tr>
                    <td>Academicians/Research Scholars</td>
                    <td>150 USD</td>
                    <td>180 USD</td>
                    <td>180 USD</td>
                    <td>210 USD</td>
                </tr>
                <tr>
                    <td>Industry Professionals</td>
                    <td>200 USD</td>
                    <td>230 USD</td>
                    <td >230 USD</td>
                    <td>260 USD</td>
                </tr>
            </table>
        </>
    )
}


export default Registration_Fees